module.exports = __webpack_public_path__ + "static/img/error.9917773.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error.gif
// module id = ULxA
// module chunks = 8